import React from 'react';
import OvulationCalculatorApp from './OvulationCalculatorApp';

function App() {
  return (
    <div>
      <OvulationCalculatorApp />
    </div>
  );
}

export default App;